import React from 'react';
import PropTypes from 'prop-types';

import { NewModel } from '../../../model';
import NewsTab from '../../containers/New/NewsTab';
import InfiniteScroller from '../../core/InfiniteScroller';

const TimelineNews = ({
  news,
  currentPage,
  loadMore,
  total,
  hasToken,
  isWidget
}) => (
  <InfiniteScroller
    page={currentPage}
    loadMore={loadMore}
    hasMore={total === news.length + 1}
  >
    {news.map(item => (
      <NewsTab
        key={item.id}
        {...item}
        orientation="horizontal"
        hastoken={hasToken}
        isWidget={isWidget}
      />
    ))}
  </InfiniteScroller>
);

TimelineNews.propTypes = {
  news: PropTypes.arrayOf(NewModel),
  currentPage: PropTypes.number,
  loadMore: PropTypes.func,
  total: PropTypes.number,
  hasToken: PropTypes.bool
};

TimelineNews.defaultProps = {
  news: []
};

export default TimelineNews;
